import styled from "@emotion/styled";
import { space, color, flexbox, height } from "styled-system";
import { gap } from "src/lib/styled-system/gap.ts";

import type {
  ColorProps,
  SpaceProps,
  FlexboxProps,
  GridGapProps,
  HeightProps,
} from "styled-system";

import type { ExactTheme } from "src/lib/emotion/theme.ts";
import type { GapProps } from "src/lib/styled-system/gap.ts";

type Theme = Omit<ExactTheme, "buttons">;

export interface FlexProps
  extends ColorProps<Theme>,
    SpaceProps<Theme>,
    GapProps,
    GridGapProps<Theme>,
    FlexboxProps<Theme>,
    HeightProps {}

export const Flex = styled.div<FlexProps>`
  display: flex;
  min-width: 0;
  min-height: 0;
  ${color}
  ${space}
  ${flexbox}
  ${gap}
  ${height};
`;
